<template>
<div>
    <v-list-item  v-ripple="phoneOnly" :class="{'px-6': phoneOnly, 'px-0': pcOnly}" :disabled="!question.answered">
        <v-list-item-icon>
            <v-avatar size="60" color="grey lighten-3" style="border-radius: 6px">
                <v-icon size="35" color="primary">mdi-file-question</v-icon>
            </v-avatar>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                <span class="muted--text">السؤال #{{question.id}}</span>
                <v-chip v-if="!question.answered" small class="ms-2 px-2" color="grey" dark>في انتظار الإجابة</v-chip>
                <v-chip v-else-if="$route.name === 'my-questions'" small class="ms-2 px-2" color="primary" dark><strong>تم الإجابة</strong></v-chip>
            </v-list-item-title>
            <v-list-item-subtitle class="text--text">
                <template v-if="question.text">{{question.text}}</template>
                <div v-else-if="question.image_url"><v-icon small class="me-1" color="grey">mdi-image</v-icon>صورة</div>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon class="ms-1">
            <v-btn v-if="question.answered" rounded color="primary" depressed dense @click="answerDialog = true;">
                <v-icon class="me-1" size="20" left>mdi-file-check-outline</v-icon>
                <span>{{pcOnly ? 'عرض الإجابة' : 'الإجابة'}}</span>
            </v-btn>
        </v-list-item-icon>
    </v-list-item>
    <v-dialog v-if="question.answered" v-model="answerDialog" max-width="600" overlay-color="#000">
        <v-card>
            <v-card-title>السؤال #{{question.id}}</v-card-title>
            <v-card-text class="mt-3">
                <div class="mb-5">
                    <div v-if="question.text" class="text--text">{{question.text}}</div>
                    <div v-if="question.image_url" class="text-center">
                        <img :src="question.image_url" style="width: 100%; height: auto; max-width: 360px;" />
                    </div>
                </div>

                <v-subheader class="details-text ps-0">الإجابة</v-subheader>

                    <div v-if="question.answer_text" class="pa-3 bordered mb-4">
                        <div class="strong-text--text" style="font-size: 0.95rem; line-height: 1.7rem; white-space: pre-line;">{{question.answer_text}}</div>
                    </div>

                    <div v-if="question.answer_image">
                        <img :src="question.answer_image" style="width: 100%; height: auto" />
                    </div>

                    <div v-if="question.answer_audio" class="bordered rounded-lg pa-1">
                        <audio-player :url="question.answer_audio" />
                    </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="muted" @click="answerDialog = false">إخفاء</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import AudioPlayer from './audio-player.vue'

export default {
    props: {
        question: {},
    },
    components: {AudioPlayer},
    data(){
        return {
            answerDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>

<style lang="scss">

</style>